































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { PPJA_ONLY_HINT } from "@/utility/AsuhanKeperawatanHelper";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import AsesmenAwalRanapPerinatalSvc from "@/services/AsesmenAwalRanapPerinatal";
import AsesmenAwalRanapPerinatalStore from "@/store/modules/AsesmenAwalRanapPerinatalStore";
import { fetchApgarBbl } from "@/utils/apgarBbl";
import IdentitasBayiBaruLahirSvc from "@/services/IdentitasBayiBaruLahir";
import { identitasApgarTotals, identitasToPerinatal } from "@/utils/identitasBbl";
import moment from "moment";

@Component({
  filters: {
    formatDatetime(val) {
      if (!val) return "-";
      return moment(val).format("DD-MM-YYYY HH:mm");
    }
  },
  inject: {
    isReadOnly: { default: () => () => false },
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class CardAsesmenPerinatal extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop({ default: false }) readonly isActive!: boolean;
  @Ref() readonly dateTimePicker;

  isReadOnly!: () => boolean;
  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  removing = false;
  verifying = false;
  verifyingPpja = false;
  isEditing = false;
  examinedAt: Date | null = null;

  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  timePickerProps = { format: "24hr", scrollable: true };

  sumberPengkajianOptions = [
    { label: "Pasien Sendiri", value: "pasien_sendiri" },
    { label: "Keluarga", value: "keluarga" },
    { label: "Lainnya", value: "lainnya" }
  ];

  nipsItems = [
    { key: "ekspresi_wajah", label: "Ekspresi Wajah" },
    { key: "tangisan", label: "Tangisan" },
    { key: "pola_nafas", label: "Pola Nafas" },
    { key: "lengan_tangan", label: "Lengan/Tangan" },
    { key: "keadaan_sadar", label: "Keadaan Sadar" }
  ];

  dischargeQuestions = [
    { key: "peralatan_medis", keyKet: "peralatan_medis_keterangan", label: "Peralatan medis khusus dibawa pulang" },
    { key: "ada_yang_merawat", keyKet: "ada_yang_merawat_keterangan", label: "Ada yang merawat di rumah" },
    { key: "perawatan_lanjut", keyKet: "perawatan_lanjut_keterangan", label: "Perawatan lanjut setelah di rumah" },
    { key: "rujukan_komunitas", keyKet: "rujukan_komunitas_keterangan", label: "Perlu rujukan ke komunitas lain" },
    { key: "edukasi_khusus", keyKet: "edukasi_khusus_keterangan", label: "Memerlukan edukasi khusus" }
  ];

  sistemSections = [
    {
      key: "sistem_pernapasan",
      label: "III. Sistem Pernapasan",
      displayFields: [
        { key: "usaha_nafas", label: "Usaha Nafas" },
        { key: "tipe_pernapasan", label: "Tipe Pernapasan" },
        { key: "retraksi_dada", label: "Retraksi Dada" },
        { key: "perkusi", label: "Perkusi" },
        { key: "ekspansi", label: "Ekspansi" }
      ]
    },
    {
      key: "sistem_kardiovaskuler",
      label: "IV. Sistem Kardiovaskuler",
      displayFields: [
        { key: "nadi", label: "Nadi" },
        { key: "bunyi_jantung", label: "Bunyi Jantung" },
        { key: "kapiler_refil", label: "Kapiler Refil" },
        { key: "akral", label: "Akral" },
        { key: "termoregulasi", label: "Termoregulasi" }
      ]
    },
    {
      key: "sistem_muskuloskeletal",
      label: "V. Sistem Muskuloskeletal",
      displayFields: [
        { key: "postur_tubuh", label: "Postur Tubuh" },
        { key: "gerakan_ekstremitas", label: "Gerakan Ekstremitas" },
        { key: "kelainan", label: "Kelainan" }
      ]
    },
    {
      key: "sistem_neurologis",
      label: "VI. Sistem Neurologis",
      displayFields: [
        { key: "pupil", label: "Pupil" },
        { key: "pergerakan", label: "Pergerakan" },
        { key: "riwayat_kejang", label: "Riwayat Kejang" }
      ]
    },
    {
      key: "integumentum",
      label: "VII. Integumentum",
      displayFields: [
        { key: "ikterik_kremer", label: "Kremer" },
        { key: "lainnya", label: "Lain-lain" }
      ]
    },
    {
      key: "nutrisi",
      label: "VIII. Nutrisi",
      displayFields: [
        { key: "status_gizi", label: "Status Gizi" },
        { key: "diet", label: "Diet" },
        { key: "cara_pemberian", label: "Cara Pemberian" },
        { key: "kemampuan_menyusui", label: "Kemampuan Menyusui" },
        { key: "posisi_menyusui", label: "Posisi Menyusui" },
        { key: "perlekatan", label: "Perlekatan" }
      ]
    },
    {
      key: "sistem_perkemihan",
      label: "IX. Sistem Perkemihan",
      displayFields: [
        { key: "bak", label: "BAK" },
        { key: "warna_urine", label: "Warna Urine" },
        { key: "frekuensi_per_hari", label: "Frekuensi (x/hari)" },
        { key: "kelainan_kongenital", label: "Kelainan Kongenital" }
      ]
    },
    {
      key: "sistem_gastrointestinal",
      label: "X. Sistem Gastrointestinal",
      displayFields: [
        { key: "frekuensi_bab_per_hari", label: "Frekuensi BAB (x/hari)" },
        { key: "warna", label: "Warna" },
        { key: "mekonium", label: "Mekonium" },
        { key: "palpasi", label: "Palpasi" },
        { key: "peristaltik_per_menit", label: "Peristaltik (x/menit)" }
      ]
    },
    {
      key: "psikososial",
      label: "XI. Psikososial & Pengetahuan",
      displayFields: [
        { key: "status_anak", label: "Status Anak" },
        { key: "hubungan_ortu_anak", label: "Hubungan Ortu-Anak" },
        { key: "orang_terdekat", label: "Orang Terdekat" },
        { key: "no_telepon", label: "No. Telepon" }
      ]
    }
  ];

  masalahKeperawatan = {
    pernapasan: ["Ketidakefektifan Bersihan Jalan Nafas", "Ketidakefektifan Pola Nafas", "Risiko Aspirasi"],
    kardiovaskuler: ["Ketidakefektifan Termoregulasi", "Hipotermia", "Hipertermia"],
    muskuloskeletal: ["Risiko Jatuh"],
    neurologis: ["Risiko Ketidakefektifan Perfusi Jaringan Otak"],
    nyeri: ["Nyeri Akut"],
    integumentum: ["Ikterik Neonatus", "Kerusakan Membran Mukosa Oral", "Kerusakan Integritas Kulit"],
    nutrisi: [
      "Risiko Ketidakstabilan Kadar Gula Darah",
      "Risiko Ketidakseimbangan Volume Cairan",
      "Ketidakefektifan Pemberian ASI",
      "Kesiapan Meningkatkan Pemberian ASI",
      "Kekurangan Volume Cairan"
    ],
    perkemihan: ["Hambatan Eliminasi Urine", "Retensi Urine"],
    gastrointestinal: ["Konstipasi", "Diare", "Kekurangan Volume Cairan"],
    psikososial: ["Cemas", "Ketidakmampuan Koping Keluarga", "Kurang Pengetahuan"]
  };

  form = this.getEmptyForm();

  get record() {
    return AsesmenAwalRanapPerinatalStore.asesmen;
  }

  get stateUser() {
    return userModule.user;
  }

  get canEdit(): boolean {
    if (this.canDelete) return true;
    return !this.readOnly && !!this.record && this.canUpdateSigned;
  }

  get canDelete(): boolean {
    if (this.readOnly) return false;
    if (!this.record) return false;
    if (this.record.dpjp_verified_at || this.record.ppja_verified_at) return false;
    return this.record.perawat_user_id === this.stateUser?.id;
  }

  get canUpdateSigned(): boolean {
    return userModule.hasPrivilege("asesmen_awal_ranap_perinatal", "update_signed");
  }

  get canVerifyDpjp(): boolean {
    if (!this.record) return false;
    if (this.record.dpjp_verified_at) return false;
    return userModule.isMedis === true;
  }

  get canVerifyAsesmenKeperawatan(): boolean {
    return userModule.canVerifyAsesmenKeperawatan;
  }

  get ppjaOnlyHint(): string {
    return PPJA_ONLY_HINT;
  }

  get canVerifyPpja(): boolean {
    if (!this.record) return false;
    if (this.record.ppja_verified_at) return false;
    // PPJA (perawat penanggung jawab asuhan) berbeda dari perawat pelaksana
    // tidak diwajibkan; cukup tidak boleh memverifikasi sebagai pembuat sendiri.
    return this.record.perawat_user_id !== this.stateUser?.id;
  }

  get downesScore(): number {
    return Number(this.form.content.riwayat_kesehatan.keadaan_umum.downes_score) || 0;
  }

  get suhuValue(): number | null {
    return this.form.content.riwayat_kesehatan.keadaan_umum.suhu || null;
  }

  get nadiValue(): number | null {
    return this.form.content.riwayat_kesehatan.keadaan_umum.nadi || null;
  }

  get pernapasanValue(): number | null {
    return this.form.content.riwayat_kesehatan.keadaan_umum.pernapasan || null;
  }

  get spo2Value(): number | null {
    return this.form.content.riwayat_kesehatan.keadaan_umum.spo2 || null;
  }

  get apgarMenit5(): number | null {
    const v = this.form.content.riwayat_persalinan.postnatal.apgar_score.menit_5;
    return v === null || v === undefined || v === "" ? null : Number(v);
  }

  get nipsTotal(): number {
    const n = this.form.content.score_nyeri_nips;
    return (Number(n.ekspresi_wajah) || 0)
      + (Number(n.tangisan) || 0)
      + (Number(n.pola_nafas) || 0)
      + (Number(n.lengan_tangan) || 0)
      + (Number(n.keadaan_sadar) || 0);
  }

  get anyDischargeYes(): boolean {
    const d = this.form.content.discharge_planning;
    return [d.peralatan_medis, d.ada_yang_merawat, d.perawatan_lanjut, d.rujukan_komunitas, d.edukasi_khusus].some(v => v === true);
  }

  updateNipsTotal() {
    this.form.content.score_nyeri_nips.total_score = this.nipsTotal;
  }

  mounted() {
    this.loadData();
  }

  @Watch("isActive")
  onActiveChanged(val: boolean) {
    if (val && !this.record) this.loadData();
  }

  async loadData() {
    await AsesmenAwalRanapPerinatalStore.getByRegister(this.register);
    if (this.record) {
      this.populateForm();
    } else {
      await this.prefillApgarFromBbl();
      await this.applyIdentitasBbl(true);
    }
  }

  // Sync antropometri dari Identitas Bayi Baru Lahir (register sama).
  // Hanya nilai non-null sumber yang ditempel; target tidak pernah dikosongkan.
  async applyIdentitasBbl(silent = false) {
    const d = await IdentitasBayiBaruLahirSvc.findByRegisterSilent(this.register);
    if (!d) {
      if (!silent) appModule.sendErrorAlert("Identitas Bayi Baru Lahir belum diisi");
      return;
    }
    const m = identitasToPerinatal(d);
    const post = this.form.content.riwayat_persalinan.postnatal;
    if (m.bbl !== null) post.bbl = m.bbl;
    if (m.panjang_badan !== null) post.panjang_badan = m.panjang_badan;
    const t = identitasApgarTotals(d);
    const ap = post.apgar_score;
    if (ap.menit_1 == null && t.menit_1 !== null) ap.menit_1 = t.menit_1;
    if (ap.menit_5 == null && t.menit_5 !== null) ap.menit_5 = t.menit_5;
    if (!silent) appModule.NoticeDelay("Antropometri diambil dari Identitas Bayi Baru Lahir");
  }

  // IMP-066: prefill APGAR dari Asesmen BBL (hanya bila masih kosong)
  async prefillApgarFromBbl() {
    const a = await fetchApgarBbl(this.register);
    if (!a) return;
    const ap = this.form.content.riwayat_persalinan.postnatal.apgar_score;
    if (ap.menit_1 == null) ap.menit_1 = a.apgar_1;
    if (ap.menit_5 == null) ap.menit_5 = a.apgar_5;
    if (ap.menit_10 == null) ap.menit_10 = a.apgar_10;
  }

  populateForm() {
    const r = this.record;
    if (!r) return;
    this.examinedAt = r.examined_at ? new Date(r.examined_at) : null;
    const empty = this.getEmptyForm();
    const incoming = this.normalizeLegacyContent(JSON.parse(JSON.stringify(r.content || {})));
    this.form.content = this.mergeContent(empty.content, incoming);
  }

  // Back-compat koreksi TIM IMP 2026-06: Gemelli/Lintang/Presbo dipindah dari
  // jenis_persalinan -> penyulit_persalinan; komplikasi (perdarahan/KPD/solusio)
  // dipindah dari penyulit_persalinan lama -> komplikasi_persalinan_items.
  // Record lama dinormalisasi saat dimuat agar tampil & tersimpan di struktur baru.
  normalizeLegacyContent(content: any): any {
    const intra = content?.riwayat_persalinan?.intranatal;
    if (!intra) return content;
    const malpresentasi = ["gemelli", "lintang", "presbo"];
    const oldPenyulit = intra.penyulit_persalinan || {};
    const isLegacy =
      intra.komplikasi_persalinan_items === undefined &&
      (malpresentasi.includes(intra.jenis_persalinan) ||
        "perdarahan" in oldPenyulit ||
        "kpd" in oldPenyulit ||
        "solusio_plasenta" in oldPenyulit);
    if (!isLegacy) return content;
    // komplikasi lama (tersimpan di penyulit_persalinan) -> komplikasi_persalinan_items
    intra.komplikasi_persalinan_items = {
      perdarahan: !!oldPenyulit.perdarahan,
      kpd: !!oldPenyulit.kpd,
      kpd_jam: oldPenyulit.kpd_jam != null ? oldPenyulit.kpd_jam : null,
      solusio_plasenta: !!oldPenyulit.solusio_plasenta,
      lainnya: !!oldPenyulit.lainnya,
      lainnya_keterangan: oldPenyulit.lainnya_keterangan || ""
    };
    // penyulit (malpresentasi) baru dari jenis_persalinan lama
    const j = intra.jenis_persalinan;
    intra.penyulit_persalinan = {
      gemelli: j === "gemelli",
      lintang: j === "lintang",
      presbo: j === "presbo",
      lainnya: false,
      lainnya_keterangan: ""
    };
    if (malpresentasi.includes(j)) intra.jenis_persalinan = null;
    return content;
  }

  get intraRaw(): any {
    return this.record?.content?.riwayat_persalinan?.intranatal || {};
  }

  get intraJenisText(): string {
    const map: any = { spontan: "Spontan", ve: "VE", sc: "SC" };
    const j = this.intraRaw.jenis_persalinan;
    return j && map[j] ? map[j] : "-";
  }

  get intraPenyulitText(): string {
    const intra = this.intraRaw;
    const p = intra.penyulit_persalinan || {};
    const hasNew = intra.komplikasi_persalinan_items != null;
    const out: string[] = [];
    if (p.gemelli || intra.jenis_persalinan === "gemelli") out.push("Gemelli");
    if (p.lintang || intra.jenis_persalinan === "lintang") out.push("Lintang");
    if (p.presbo || intra.jenis_persalinan === "presbo") out.push("Presbo");
    if (hasNew && p.lainnya) out.push(p.lainnya_keterangan || "Lainnya");
    return out.length ? out.join(", ") : "-";
  }

  get intraKomplikasiText(): string {
    const intra = this.intraRaw;
    const k = intra.komplikasi_persalinan_items != null ? intra.komplikasi_persalinan_items : intra.penyulit_persalinan || {};
    const out: string[] = [];
    if (k.perdarahan) out.push("Perdarahan");
    if (k.kpd) out.push(`KPD${k.kpd_jam ? ` (${k.kpd_jam} jam)` : ""}`);
    if (k.solusio_plasenta) out.push("Solusio Plasenta");
    if (k.lainnya) out.push(k.lainnya_keterangan || "Lainnya");
    if (intra.komplikasi_persalinan) out.push(intra.komplikasi_persalinan);
    return out.length ? out.join(", ") : "-";
  }

  get intraAirKetubanText(): string {
    const intra = this.intraRaw;
    const v = intra.air_ketuban;
    if (!v) return "-";
    if (v === "lainnya") return intra.air_ketuban_lainnya ? `Lainnya: ${intra.air_ketuban_lainnya}` : "Lainnya";
    const map: any = { jernih: "Jernih", keruh: "Keruh", hijau: "Hijau" };
    return map[v] || v;
  }

  mergeContent(defaults, override) {
    const result = JSON.parse(JSON.stringify(defaults));
    const walk = (target, source) => {
      for (const key of Object.keys(source || {})) {
        const val = source[key];
        if (val !== null && typeof val === "object" && !Array.isArray(val)) {
          if (!target[key] || typeof target[key] !== "object") target[key] = {};
          walk(target[key], val);
        } else {
          target[key] = val;
        }
      }
    };
    walk(result, override);
    return result;
  }

  getEmptyForm() {
    return {
      content: {
        sumber_pengkajian: "keluarga",
        riwayat_kesehatan: {
          keluhan_utama: "",
          riwayat_penyakit_sekarang: "",
          diagnosis_medis: "",
          keadaan_umum: {
            state_of_alertness: null,
            downes_score: null,
            suhu: null,
            nadi: null,
            bbs: null,
            tekanan_darah_sistol: null,
            tekanan_darah_diastol: null,
            pernapasan: null,
            spo2: null
          }
        },
        riwayat_persalinan: {
          antenatal: {
            penyulit_kehamilan: { hiperemesis: false, preeklampsia: false, perdarahan: false, perdarahan_keterangan: "", lainnya: false, lainnya_keterangan: "" },
            penyakit_saat_kehamilan: ""
          },
          intranatal: {
            umur_kehamilan_minggu: null,
            jenis_persalinan: null,
            penyulit_persalinan: { gemelli: false, lintang: false, presbo: false, lainnya: false, lainnya_keterangan: "" },
            komplikasi_persalinan_items: { perdarahan: false, kpd: false, kpd_jam: null, solusio_plasenta: false, lainnya: false, lainnya_keterangan: "" },
            komplikasi_persalinan: "",
            air_ketuban: null,
            air_ketuban_lainnya: ""
          },
          postnatal: {
            bbl: null,
            panjang_badan: null,
            trauma_lahir: "",
            apgar_score: { menit_1: null, menit_5: null, menit_10: null },
            imunisasi: null,
            imunisasi_lainnya: "",
            refleks_neonatus: { hisap: null, menelan: null, moro: null, tonik_leher: null, palmar_grasp: null }
          }
        },
        sistem_pernapasan: {
          usaha_nafas: null, bantuan_nafas: null, tipe_pernapasan: null,
          nafas_cuping_hidung: false, lendir: false, lendir_warna: "",
          retraksi_dada: false, otot_nafas_tambahan: false,
          perkusi: null, ekspansi: null, auskultasi: [],
          masalah_keperawatan: []
        },
        sistem_kardiovaskuler: {
          nadi: null, bunyi_jantung: null, kapiler_refil: null,
          akral: null, termoregulasi: null, masalah_keperawatan: []
        },
        sistem_muskuloskeletal: {
          kelainan: "", postur_tubuh: null, gerakan_ekstremitas: null,
          kekuatan_ekstremitas: { kaki_kanan: null, kaki_kiri: null, tangan_kanan: null, tangan_kiri: null },
          ctev: false, ctev_lokasi: "", spina_bifida: false,
          masalah_keperawatan: []
        },
        sistem_neurologis: {
          riwayat_kejang: "", pergerakan: "",
          kejang: false, kejang_keterangan: "",
          pupil: null, masalah_keperawatan: []
        },
        score_nyeri_nips: {
          ekspresi_wajah: 0, tangisan: 0, pola_nafas: 0,
          lengan_tangan: 0, keadaan_sadar: 0, total_score: 0,
          masalah_keperawatan: []
        },
        integumentum: {
          warna_kulit: [], ikterik_kremer: null,
          luka_lesi: false, luka_lesi_jenis: "", luka_lesi_lokasi: "",
          ukk: false, ukk_jenis: "", ukk_lokasi: "",
          lainnya: "", masalah_keperawatan: []
        },
        nutrisi: {
          status_gizi: null, diet: "", puasa: false,
          intake_enteral_cc: null, cara_pemberian: null,
          mukosa_mulut: null, lidah: null,
          kemampuan_menyusui: "", imd: true, imd_tidak_alasan: "",
          posisi_menyusui: null, perlekatan: null,
          masalah_keperawatan: []
        },
        sistem_perkemihan: {
          bak: null, bak_dower_jumlah_cc: null, warna_urine: null,
          frekuensi_per_hari: null, kelainan_kongenital: "",
          masalah_keperawatan: []
        },
        sistem_gastrointestinal: {
          frekuensi_bab_per_hari: null, konsistensi: [], warna: null,
          mekonium: null, palpasi: null, perkusi: null,
          peristaltik_per_menit: null, muntah: false, muntah_frekuensi_per_hari: null,
          lainnya: "", masalah_keperawatan: []
        },
        psikososial: {
          orang_terdekat: "", no_telepon: "",
          status_anak: null, respon_orang_tua: [],
          hubungan_ortu_anak: null,
          pengetahuan_ortu_bertanya: "", ortu_mengerti_penyakit: true,
          masalah_keperawatan: []
        },
        discharge_planning: {
          tinggal_bersama: "orangtua", tinggal_bersama_lainnya: "",
          peralatan_medis: false, peralatan_medis_keterangan: "",
          ada_yang_merawat: false, ada_yang_merawat_keterangan: "",
          perawatan_lanjut: false, perawatan_lanjut_keterangan: "",
          rujukan_komunitas: false, rujukan_komunitas_keterangan: "",
          edukasi_khusus: false, edukasi_khusus_keterangan: ""
        },
        data_penunjang: "",
        terapi: "",
        diagnosa_keperawatan: []
      }
    };
  }

  populateDiagnosaFromMasalah() {
    const c = this.form.content;
    const all: string[] = [
      ...(c.sistem_pernapasan.masalah_keperawatan || []),
      ...(c.sistem_kardiovaskuler.masalah_keperawatan || []),
      ...(c.sistem_muskuloskeletal.masalah_keperawatan || []),
      ...(c.sistem_neurologis.masalah_keperawatan || []),
      ...(c.score_nyeri_nips.masalah_keperawatan || []),
      ...(c.integumentum.masalah_keperawatan || []),
      ...(c.nutrisi.masalah_keperawatan || []),
      ...(c.sistem_perkemihan.masalah_keperawatan || []),
      ...(c.sistem_gastrointestinal.masalah_keperawatan || []),
      ...(c.psikososial.masalah_keperawatan || [])
    ];
    const unique = [...new Set(all)].slice(0, 4);
    this.form.content.diagnosa_keperawatan = unique;
  }

  get requestParams() {
    this.form.content.score_nyeri_nips.total_score = this.nipsTotal;
    const examinedAt = this.examinedAt
      ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateUser?.unit_id || null,
      examined_at: examinedAt,
      perawat_user_id: this.stateUser?.id,
      content: this.form.content,
      version: "1.0"
    };
  }

  async save() {
    if (this.readOnly) return;
    if (this.saving) return;
    this.saving = true;
    try {
      const req = this.record
        ? AsesmenAwalRanapPerinatalSvc.update(this.record.id, this.requestParams)
        : AsesmenAwalRanapPerinatalSvc.create(this.requestParams);
      await req;
      appModule.NoticeDelay("Berhasil Simpan Asesmen Awal Perinatal");
      this.isEditing = false;
      await this.loadData();
    } finally {
      this.saving = false;
    }
  }

  async remove() {
    if (this.readOnly) return;
    if (this.removing || !this.record) return;
    if (!confirmRemove("Asesmen Awal Perinatal")) return;
    this.removing = true;
    try {
      await AsesmenAwalRanapPerinatalSvc.destroy(this.record.id);
      appModule.NoticeDelay("Berhasil Hapus Asesmen Awal Perinatal");
      await AsesmenAwalRanapPerinatalStore.reset();
      this.form = this.getEmptyForm();
      this.examinedAt = null;
    } finally {
      this.removing = false;
    }
  }

  async verifyDpjp() {
    if (this.verifying || !this.record || this.verifikasiTerkunci) return;
    if (!confirm("Apakah Anda yakin memverifikasi Asesmen Awal Perinatal ini sebagai DPJP?")) return;
    this.verifying = true;
    try {
      await AsesmenAwalRanapPerinatalSvc.verifyByDpjp(this.record.id, {
        dpjp_user_id: this.stateUser?.id
      });
      appModule.NoticeDelay("Berhasil Verifikasi DPJP");
      await this.loadData();
    } finally {
      this.verifying = false;
    }
  }

  async verifyPpja() {
    if (this.verifyingPpja || !this.record || this.verifikasiTerkunci) return;
    if (!confirm("Apakah Anda yakin memverifikasi Asesmen Awal Perinatal ini sebagai PPJA?")) return;
    this.verifyingPpja = true;
    try {
      await AsesmenAwalRanapPerinatalSvc.verifyByPpja(this.record.id, {
        ppja_user_id: this.stateUser?.id
      });
      appModule.NoticeDelay("Berhasil Verifikasi PPJA");
      await this.loadData();
    } finally {
      this.verifyingPpja = false;
    }
  }

  cancelEdit() {
    this.isEditing = false;
    if (this.record) this.populateForm();
  }

  cetakPdf() {
    if (this.record) AsesmenAwalRanapPerinatalSvc.print(this.record.id);
  }

  contentVal(path: string, def = "-"): string {
    if (!this.record?.content) return def;
    const keys = path.split(".");
    let val: any = this.record.content;
    for (const k of keys) {
      if (val == null) return def;
      val = val[k];
    }
    if (val === null || val === undefined || val === "") return def;
    if (typeof val === "boolean") return val ? "Ya" : "Tidak";
    return String(val);
  }

  contentArr(path: string): any[] {
    if (!this.record?.content) return [];
    const keys = path.split(".");
    let val: any = this.record.content;
    for (const k of keys) {
      if (val == null) return [];
      val = val[k];
    }
    return Array.isArray(val) ? val : [];
  }

  contentLabel(val: string, options: { value: string; label: string }[]): string {
    const found = options.find(o => o.value === val);
    return found ? found.label : val || "-";
  }

  formatList(list: any[]): string {
    return list && list.length ? list.join(", ") : "-";
  }

  boolLabel(boolPath: string, ketPath: string): string {
    const b = this.contentVal(boolPath);
    if (b === "Ya") {
      const ket = this.contentVal(ketPath);
      return ket !== "-" ? `Ya - ${ket}` : "Ya";
    }
    return b;
  }
}
